<div
    class="hero"
    title="astra Versicherung AG - Einfach gut geschützt"
>
    <img
        id="person"
        src="/assets/img/homepage_hero_person.png"
        alt=""
        role="presentation"
    />
    <div class="hero-text-box">
        <span class="h1 lg:hide">Einfach gut versichert.</span>
        <div class="hide lg:show">
            <span class="h1">Weil dein Handy mehr<br />ist als nur ein Gerät!</span>
            <a
                [routerLink]="['/', 'produkte', 'handyversicherung', '']"
                class="button m-48:t"
                >Zur Handyversicherung <i ctrlIcon="arrow_right"></i
            ></a>
        </div>
    </div>
</div>
